// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"8bc4a14c","703":"685340cc"}[chunkId] + ".chunk.js";
};